module.exports = __webpack_public_path__ + "static/media/img-productos-acero.535a0648.png";